import React, {useCallback, useMemo} from 'react';
import {useLocalization} from 'localization';
import {
  useGetManifestationFileInfoQuery,
  useLazyGetManifestationDownloadFileInfoQuery,
} from 'services/metadata/manifestationApi';
import {Spacer, ToolButton} from 'components';

type Props = {
  ean: string;
  miniMode?: boolean;
};

export const ManifestationDownload: React.FC<Props> = ({ean, miniMode}) => {
  const {data} = useGetManifestationFileInfoQuery({ean});
  const [getManifestationDownloadFileInfoQuery] =
    useLazyGetManifestationDownloadFileInfoQuery();

  const {t} = useLocalization();

  const onClick = useCallback(() => {
    getManifestationDownloadFileInfoQuery({ean})
      .unwrap()
      .then(result => {
        if (result.url) {
          window.open(result.url, '_blank');
        }
      });
  }, [ean, getManifestationDownloadFileInfoQuery]);

  return useMemo(() => {
    if (data?.hasFile) {
      return (
        <>
          <Spacer size={1} />
          <ToolButton
            title={t('page.metadata.manifestation.tools.download')}
            icon="Download"
            onClick={onClick}
            iconOnly={miniMode}
          />
        </>
      );
    }

    return null;
  }, [data?.hasFile, miniMode, onClick, t]);
};
